import React from "react";
import { Box, Typography } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import dayjs from "dayjs";
import {
  deleteQuotation,
  getQuotationList,
  updateQuotationStatus,
} from "../../api/quotations/index.ts";
import StatusManager from "../../molecules/Inventory/StatusManager.tsx";
import QuotingFormHeader, {
  QuotingFormData,
} from "../../molecules/Quoting/QuotingFormHeader.tsx";
import QuotingPlot from "../../molecules/Quoting/QuotingPlot.tsx";
import QuotingQuantitiesCSV from "../../molecules/Quoting/QuotingQuantitiesCSV.tsx";
import EstimateReportViewer from "../../molecules/Quoting/EstimateReportViewer.tsx";
import EstimateItemForm from "./EstimateItemForm.tsx";

const CrudQuoting = () => {
  const { selectedCompany } = useCompany();

  if (!selectedCompany) {
    return (
      <Box p={4}>
        <Typography>Seleccione una compañía primero</Typography>
      </Box>
    );
  }

  const handleQuotingSubmit = async (data: QuotingFormData) => {
    // TODO: Implement API call to save quoting header
    console.log("Quoting data:", data);
  };

  // Wrapper component to receive the selected row data
  const EstimateReportWrapper = ({ selectedRow }: { selectedRow: any }) => {
    if (!selectedRow || !selectedRow.id) {
      return (
        <Box p={2}>
          <Typography color="text.secondary">
            Seleccione una cotización para ver su reporte detallado.
          </Typography>
        </Box>
      );
    }
    return <EstimateReportViewer estimateId={selectedRow.id} />;
  };

  const quotationCrudProps = {
    fetchFunction: getQuotationList,
    deleteFunction: deleteQuotation,
    data: { companyId: selectedCompany.id },
    detailMenu: [
      {
        label: "Componentes",
        handler: () => {},
        header: "Componentes",
        body: <EstimateItemForm />,
      },
      {
        label: "Gráfico de Costos",
        handler: () => {},
        header: "Gráfico de Costos por Cantidad",
        body: <QuotingPlot />,
      },
      {
        label: "Descargar Reporte de Costos",
        handler: () => {},
        header: "Reporte de Costos",
        body: <QuotingQuantitiesCSV />,
      },
      {
        label: "Ver Reporte Detallado",
        handler: () => {},
        header: "Reporte Detallado de la Cotización",
        body: <EstimateReportViewer />, // This will be updated dynamically by LGModalCrud
      },
    ],
    columns: [
      { field: "id", headerName: "ID", flex: 0.05 },
      {
        field: "code",
        headerName: "Código",
        flex: 0.15,
      },
      {
        field: "name",
        headerName: "Nombre",
        flex: 0.2,
      },
      {
        field: "subtotal",
        headerName: "Subtotal Unitario",
        flex: 0.15,
        valueFormatter: (value) => {
          return new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
          }).format(value);
        },
      },
      {
        field: "createdAt",
        headerName: "Fecha de Creación",
        flex: 0.2,
        valueFormatter: (value) => {
          if (!value) return "-";
          return dayjs(value).format("YYYY-MM-DD");
        },
      },
    ],
    addModalData: {
      header: "Nueva Cotización",
      body: <QuotingFormHeader onSubmit={handleQuotingSubmit} />,
    },
    editModalData: {
      header: "Editar Cotización",
      body: <QuotingFormHeader onSubmit={handleQuotingSubmit} />,
    },
    actions: ["create", "update", "delete", "detail"],
    customButtons: [],
  };

  return <LGModalCrud props={quotationCrudProps} />;
};

export default CrudQuoting;
